module.exports = __webpack_public_path__ + "static/media/Screen mockup (REPLACE FILL).c207803c.png";